/* eslint-disable max-len */
import React from 'react'
import Input from '../../../../../components/InputBox'
import ProfileImageUpload from '../../../../../components/ProfileImageUpload'
import FileUploadIcon from '../../../../../components/FileUploadIcon'
import DropDownComponent from './DropDownComponent'
import { StateList } from '../../../../../components/Helper/StateList'

const ContactDetails = ({ 
    handleInput,
    handleDropdown,
    submitSelected,
    setsubmitSelected,
    handleDropDownValue,
    imageSizeInfoHover,
    setImageSizeInfoHover,
    setformatError,
    setimageLoading,
    handleCheckbox,
    parentDetails,
    setParentDetails,
    handleParentInput,
    showDropdown,
    stateStatus,
    customError,
    isValidation,
    setToastErrorMessage,
    studentDetails,
    handleParentCheckbox }) => {
        
    const panCardRegex=/[A-Z]{5}[0-9]{4}[A-Z]{1}/

    /**
     * The function `handlePanCheck` checks if a given PAN number (Indian Permanent Account Number)
     * matches a regular expression pattern.
     * @returns a boolean value indicating whether the given `pan_number` matches the regular
     * expression `panCardRegex`.
     */
    const handlePanCheck=(pan_number)=>{
        return panCardRegex.test(pan_number)
    }

    return (
        <div class="border border-[#D0D5DD] p-3 rounded contact_details_section mb-8">
            <div class="flex">
                <div class="w-1/2 pr-4">
                    <p class="text-f7 font-semibold text-[#031624] pb-3">Student Contact Details</p>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Address Line 1<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='address_line1'
                            isMandatoryField={true}
                            placeholder="Enter Address"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Address Line 2<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='address_line2'
                            isMandatoryField={true}
                            placeholder="Enter Address"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">PIN Code<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            maxLength={6}
                            state={studentDetails}
                            id='pin_code'
                            isMandatoryField={true}
                            placeholder="Enter PIN Code"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            customError={customError}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Area<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='area'
                            maxLength={64}
                            inputWidth={`w-[53%] 2xl:w-[50%]`}
                            isMandatoryField={true}
                            placeholder="Enter Area"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">City<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='city'
                            maxLength={64}
                            inputWidth={`w-[53%] 2xl:w-[50%]`}
                            isMandatoryField={true}
                            placeholder="City"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">State<span class="req-fld-astrk">*</span></label>
                        <DropDownComponent
                            stateStatus={stateStatus}
                            divClassName={'relative w-[53%] 2xl:w-[50%]'} 
                            showErrorBorder={submitSelected && studentDetails.state === ""} 
                            applyBGForDisabled={true}
                            isMandatoryField={true}
                            options={StateList}
                            dropdownkey={"state"}
                            studentDetails={studentDetails}
                            submitSelected={submitSelected}
                            handleDropDownValue={handleDropDownValue}
                            showDropdown={showDropdown}
                            handleDropdown={handleDropdown}
                            placeholder={"State"}
                            selectedvalue={studentDetails.state}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Email Address<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='email_address'
                            inputWidth={`w-[53%] 2xl:w-[50%]`}
                            isMandatoryField={true}
                            placeholder="Enter Email Address"
                            handleInput={handleInput}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            customError={customError}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Mobile Number<span class="req-fld-astrk">*</span></label>
                        <Input
                            type="text"
                            state={studentDetails}
                            id='mobile_number'
                            maxLength={10}
                            inputWidth={`w-[53%] 2xl:w-[50%]`}
                            isMandatoryField={true}
                            placeholder="Enter Mobile No."
                            handleInput={handleInput}
                            submitSelected={(isValidation && studentDetails.mobile_number?.length !== 10) || submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            customError={customError}
                        />
                    </div>
                </div>
                <div class="w-1/2 pl-4 border-l border-[#D0D5DD]">
                    <p class="text-f7 font-semibold text-[#031624] pb-3">Emergency Contact Details</p>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Name</label>
                        <Input
                            type="text"
                            state={parentDetails}
                            maxLength={30}
                            id='emergency_contact_name'
                            inputWidth={`w-[42%] 2xl:w-[50%]`}
                            placeholder="Enter Name"
                            handleInput={handleParentInput}
                            //submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                        />
                    </div>
                    <div class="flex items-center w-full mb-4">
                        <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Mobile Number</label>
                        <Input
                            type="text"
                            state={parentDetails}
                            id='emergency_contact_mobile_number'
                            maxLength={10}
                            inputWidth={`w-[42%] 2xl:w-[50%]`}
                            placeholder="Enter Mobile No."
                            handleInput={handleParentInput}
                            submitSelected={parentDetails.emergency_contact_mobile_number !== "" && parentDetails.emergency_contact_mobile_number?.length !== 10 && isValidation}
                            setsubmitSelected={setsubmitSelected}
                            customError={customError}
                        />
                    </div>
                </div>
            </div>
            <div class="border-t border-[#D0D5DD] mt-4">
                {/*<!-- father details section --> */}
                <div class={`pb-2.5 ${studentDetails.is_father_details ? "" :"border py-2.5"} ${submitSelected && !studentDetails.is_father_details && !studentDetails.is_mother_details ? 'border-[#F04438]' : 'border-[#D0D5DD]'}  rounded mt-4 error_border parent_details_spacing`}>
                    <div class="relative checkbox custom-checkBoxBlueBranch1">
                        <input 
                            type="checkbox" 
                            id="checkbox-a1"
                            onClick={() => {handleCheckbox('is_father_details'), setsubmitSelected(false)}}
                            checked={studentDetails.is_father_details}
                        />
                        <label for="checkbox-a1" class="text-f7 font-semibold text-[#031624] pl-3 w-full cursor-pointer show_parents_details_form">Father Details</label>
                    </div>
                </div>
                <div class={`p-3 border border-[#D0D5DD] rounded ${studentDetails.is_father_details === true ? '' : 'hidden'} parents_details`}>
                    <div class="flex">
                        <div class="pr-4 w-1/2">
                            <ProfileImageUpload
                                mainKey="student"
                                imageid={"father_image_url"}
                                studentDetails={parentDetails}
                                setStudentDetails={setParentDetails}
                                imageSizeInfoHover={imageSizeInfoHover}
                                setImageSizeInfoHover={setImageSizeInfoHover}
                                setformatError={setformatError}
                                setimageLoading={setimageLoading}
                                setToastErrorMessage={setToastErrorMessage}
                            />
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">First Name<span class="req-fld-astrk">*</span></label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    id='father_first_name'
                                    maxLength={30}
                                    isMandatoryField={true}
                                    placeholder="Enter First Name"
                                    handleInput={handleParentInput}
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                />
                            </div>
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Middle Name</label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    id='father_middle_name'
                                    maxLength={30}
                                    isMandatoryField={true}
                                    placeholder="Enter Middle Name"
                                    handleInput={handleParentInput}
                                    //submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                />
                            </div>
                            <div class="flex items-center w-full">
                                <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Last Name</label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    id='father_last_name'
                                    maxLength={30}
                                    isMandatoryField={true}
                                    placeholder="Enter Last Name"
                                    handleInput={handleParentInput}
                                    //submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                />
                            </div>
                        </div>
                        <div class="pl-4 w-1/2 border-l border-[#D0D5DD] mt-[58px]">
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Email Address<span class="req-fld-astrk">*</span></label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    id='father_email_address'
                                    placeholder="Enter Email Address"
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    handleInput={handleParentInput}
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                                {(
                                    <div className="relative checkbox custom-checkBoxBlue1 mb-3 more-lines flex ml-2">
                                        <input
                                            type="checkbox"
                                            id="send_father_invite"
                                            autocompleted="send_father_invite"
                                            checked={parentDetails.send_father_invite}
                                            disabled={!parentDetails.father_email_address}
                                            onChange={() => handleParentCheckbox('send_father_invite')}
                                        />
                                        <label htmlFor="send_father_invite"
                                        >
                                            Send Invite
                                        </label>
                                    </div>)}
                            </div>
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Mobile Number</label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    maxLength={10}
                                    id='father_mobile_number'
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    placeholder="Enter Mobile No." 
                                    handleInput={handleParentInput}
                                    submitSelected={isValidation && parentDetails.father_mobile_number?.length !== 10 && parentDetails.father_mobile_number !== ""}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                            </div>
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">PAN<span class="req-fld-astrk">*</span></label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    id='father_pan_number'
                                    maxLength={10}
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    placeholder="Enter PAN"
                                    handleInput={handleParentInput}
                                    submitSelected={(isValidation &&  !handlePanCheck(parentDetails.father_pan_number) && parentDetails.father_pan_number !== "") || (studentDetails.is_father_details && submitSelected)}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                            </div>
                            <div class="flex items-center w-full">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex adharUploaded">Aadhaar No.</label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    maxLength={12}
                                    id='father_aadhar_number'
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    placeholder="Enter Aadhaar No."
                                    handleInput={handleParentInput}
                                    submitSelected={isValidation && parentDetails.father_aadhar_number?.length !== 12 && parentDetails.father_aadhar_number !== ""}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                                <div class="ml-1">
                                    <FileUploadIcon
                                        state={parentDetails}
                                        fileId="father_aadhar_file"
                                        mainKey="student"
                                        setstate={setParentDetails}
                                        submitSelected={submitSelected}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class={`py-2.5 ${studentDetails.is_mother_details ? "" :"border py-2.5"} ${submitSelected && !studentDetails.is_father_details && !studentDetails.is_mother_details ? 'border-[#F04438]' : 'border-[#D0D5DD]'} rounded mt-2 error_border parent_details_spacing`}>
                    <div class="relative checkbox custom-checkBoxBlueBranch1">
                        <input 
                            type="checkbox" 
                            id="checkbox-a2"
                            onClick={() => {handleCheckbox('is_mother_details'), setsubmitSelected(false)}}
                            checked={studentDetails.is_mother_details}
                        />
                        <label for="checkbox-a2" class="text-f7 font-semibold text-[#031624] pl-3 w-full cursor-pointer show_parents_details_form">Mother Details</label>
                    </div>
                </div>
                <div class={`p-3 border border-[#D0D5DD] ${studentDetails.is_mother_details === true ? '' : 'hidden'} rounded parents_details`}>
                    <div class="flex">
                        <div class="pr-4 w-1/2">
                            <ProfileImageUpload
                                mainKey="student"
                                imageid={"mother_image_url"}
                                studentDetails={parentDetails}
                                setStudentDetails={setParentDetails}
                                imageSizeInfoHover={imageSizeInfoHover}
                                setImageSizeInfoHover={setImageSizeInfoHover}
                                setformatError={setformatError}
                                setimageLoading={setimageLoading}
                                setToastErrorMessage={setToastErrorMessage}
                            />
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">First Name<span class="req-fld-astrk">*</span></label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    id='mother_first_name'
                                    maxLength={30}
                                    isMandatoryField={true}
                                    placeholder="Enter First Name"
                                    handleInput={handleParentInput}
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                />
                            </div>
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Middle Name</label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    maxLength={30}
                                    id='mother_middle_name'
                                    isMandatoryField={true}
                                    placeholder="Enter Middle Name"
                                    handleInput={handleParentInput}
                                    //submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                />
                            </div>
                            <div class="flex items-center w-full">
                                <label class="text-f7 font-normal text-[#031624] min-w-[118px] inline-flex">Last Name</label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    maxLength={30}
                                    id='mother_last_name'
                                    isMandatoryField={true}
                                    placeholder="Enter Last Name"
                                    handleInput={handleParentInput}
                                    //submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                />
                            </div>
                        </div>
                        <div class="pl-4 w-1/2 border-l border-[#D0D5DD] mt-[60px]">
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Email Address<span class="req-fld-astrk">*</span></label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    id='mother_email_address'
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    placeholder="Enter Email Address"
                                    handleInput={handleParentInput}
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                                {<div className="relative checkbox custom-checkBoxBlue1 mb-3 more-lines flex ml-2">
                                    <input
                                        type="checkbox"
                                        id="send_mother_invite"
                                        autocompleted="send_mother_invite"
                                        disabled={!parentDetails.mother_email_address}
                                        checked={parentDetails.send_mother_invite}
                                        onChange={() => handleParentCheckbox('send_mother_invite')}
                                    />
                                    <label
                                        htmlFor="send_mother_invite"
                                    >
                                        Send Invite
                                    </label>
                                </div>}
                            </div>
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">Mobile Number</label>
                                <Input
                                    type="text"
                                    maxLength={10}
                                    state={parentDetails}
                                    id='mother_mobile_number'
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    placeholder="Enter Mobile No." 
                                    handleInput={handleParentInput}
                                    submitSelected={isValidation && parentDetails.mother_mobile_number?.length !== 10 && parentDetails.mother_mobile_number !== ""}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                            </div>
                            <div class="flex items-center w-full mb-4">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex">PAN<span class="req-fld-astrk">*</span></label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    maxLength={10}
                                    id='mother_pan_number'
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    placeholder="Enter PAN"
                                    handleInput={handleParentInput}
                                    submitSelected={(isValidation &&  !handlePanCheck(parentDetails.mother_pan_number) && parentDetails.mother_pan_number !== "") || (studentDetails.is_mother_details && submitSelected)}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                            </div>
                            <div class="flex items-center w-full">
                                <label class="text-f7 font-normal text-[#031624] min-w-[138px] inline-flex adharUploaded">Aadhaar No.</label>
                                <Input
                                    type="text"
                                    state={parentDetails}
                                    maxLength={12}
                                    id='mother_aadhar_number'
                                    inputWidth={`w-[42%] 2xl:w-[50%]`}
                                    placeholder="Enter Aadhaar No."
                                    handleInput={handleParentInput}
                                    submitSelected={isValidation && parentDetails.mother_aadhar_number?.length !== 12 && parentDetails.mother_aadhar_number !== ""}
                                    setsubmitSelected={setsubmitSelected}
                                    customError={customError}
                                />
                                <div class="ml-1">
                                    <FileUploadIcon
                                        state={parentDetails}
                                        fileId="mother_aadhar_file"
                                        mainKey="student"
                                        setstate={setParentDetails}
                                        submitSelected={submitSelected}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  )
}

export default ContactDetails